(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46071],{

/***/ 53557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index_Review; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Index/Review.module.css
var Review_module = __webpack_require__(2082);
var Review_module_default = /*#__PURE__*/__webpack_require__.n(Review_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Index/GoogleReviewsData.js
var googleReviews = [
    {
        text: "Her\u015Fey d\xfczenli ve belli kurallara g\xf6re i\u015Fliyor s\xfcre\xe7 gayet ba\u015Far\u0131l\u0131 ve kald\u0131\u011F\u0131m\u0131z yer foto\u011Fraftakiler gibiydi villa sahibi abi sa\u011Folsun her s\xfcre\xe7te ilgiliydi konum olarak manzara g\xfczeldi memnun kald\u0131k te\u015Fekk\xfcrler her\u015Fey i\xe7in.",
        name: "Mustafa O\u011Fuz",
        rating: 5
    },
    {
        text: "\u0130rem Han\u0131m \xe7ok i\xe7ten ve ilgiliydi.Kendisine te\u015Fekk\xfcr ederiz. \u0130n\u015Fallah tatilimizde \xe7ok g\xfczel ge\xe7er,ayn\u0131 ilgiyi orada da bekliyoruz.",
        name: "mustafa \xf6zdemir",
        rating: 5
    },
    {
        text: "Villa Villam arac\u0131l\u0131\u011F\u0131yla kiralad\u0131\u011F\u0131m\u0131z Villa Nefise\u2019de ge\xe7irdi\u011Fimiz tatilden \xe7ok memnun kald\u0131k. Rezervasyon s\xfcrecinden tatilimizin sonuna kadar herhangi bir sorun ya\u015Famad\u0131k. Villa, foto\u011Fraflarda g\xf6r\xfcnd\xfc\u011F\xfc gibi temiz, d\xfczenli ve olduk\xe7a",
        name: "Okan Kara\xe7il",
        rating: 5
    },
    {
        text: "22-26 Nisan i\xe7in Villa Cunday\u0131 kiralad\u0131k. \u015Eu an da villadan yorum yaz\u0131yorum. Villay\u0131 havuz \u0131s\u0131tmal\u0131 kiralad\u0131k. K\xfc\xe7\xfck \xe7ocu\u011Fumuz oldu\u011Fu i\xe7in \xf6zellikle bizim i\xe7in havuzun s\u0131cak olmas\u0131 \xf6nemliydi. Bunun i\xe7in ekstra 8000 TL \xf6dedik. Havuzun 2 g\xfcn",
        name: "didem uysal",
        rating: 5
    },
    {
        text: "\u0130lk defa villa kiralad\u0131m, \xe7ok duyduk s\u0131k\u0131nt\u0131 ya\u015Fayanlar\u0131, ancak villa villam ve Kalkan da konaklad\u0131\u011F\u0131m\u0131z villa mehtap sahibi Mehmet Bey \xe7ok ilgilendi, ev ve havuz \xe7ok temiz, havuz g\xfcnl\xfck temizlendi, plaj havlusu, normal havlu ve mutfak",
        name: "YILDIRIM \xc7EV\u0130K",
        rating: 5
    },
    {
        text: "Villa myore 7 Ge\xe7irdi\u011Fimiz tatil boyunca her \u015Fey beklentimizin \xfczerindeydi. Villa son derece temiz, konforlu ve foto\u011Fraflarda g\xf6r\xfcld\xfc\u011F\xfcnden bile daha g\xfczeldi. Sessizli\u011Fi,",
        name: "\u201Cmere\u015Fevi\u201D re\u015Fat beytekin",
        rating: 5
    },
    {
        text: "Yard\u0131m \xe7ok iyiydi. Verilen hizmetten \xe7ok memnun kald\u0131m. Her \u015Fey h\u0131zl\u0131 ve sorunsuz bir \u015Fekilde \xe7\xf6z\xfcld\xfc. Te\u015Fekk\xfcr ederim.",
        name: "Zeynep Senol",
        rating: 5
    },
    {
        text: "Ger\xe7ektende \xe7ok guzel bir tatil ya\u015Fad\u0131k villam\u0131z ayn\u0131 resimlerdeki gibiydi ve villa sahibi ailesi a\u015F\u0131r\u0131 iyi insanlar a\u015F\u0131r\u0131 ilgi g\xf6sterildi gece 1 de bile site bana yard\u0131mc\u0131 oldu rezervasyondan konaklamaya kadar her \u015Fey \xe7ok iyidi \u0131s\u0131tmal\u0131",
        name: "erman sert",
        rating: 5
    },
    {
        text: "Rezervasyonumuzu yaparken \u0130rem han\u0131m ile birlikle ilerledik. Sab\u0131rla yard\u0131mc\u0131 oldu. \u0130lgisi i\xe7in ayr\u0131ca te\u015Fekk\xfcr ediyorum. Sorunsuz bir \u015Fekilde en do\u011Fru adreste en iyi \xe7al\u0131\u015Fanlarla tatilimizi planlad\u0131k.",
        name: "demet \xf6zdemir",
        rating: 5
    },
    {
        text: "Tek kelime ile m\xfckemmel \xf6zellikte temizlik konusunda a\u015F\u0131r\u0131 derecede iyi. Temizlik tak\u0131nt\u0131s\u0131 olanlar hi\xe7 d\xfc\u015F\xfcnmeden gelebilir. Onun d\u0131\u015F\u0131nda \xe7ok samimi bir meydana sahip esnaf \xe7ok g\xfcler y\xfczl\xfc hizmet ve memnuniyet i\xe7in ellerinden geleni yap\u0131yorlar. Tam bir fiyat performans tatil diyebiliriz ka\xe7\u0131rmay\u0131n..",
        name: "iso",
        rating: 5
    },
    {
        text: "Villaya ger\xe7ekten bay\u0131ld\u0131k. Her \u015Fey en ince ayr\u0131nt\u0131s\u0131na kadar d\xfc\u015F\xfcn\xfclm\xfc\u015F, \xf6zellikle temizli\u011Fi ve d\xfczeni ger\xe7ekten harikayd\u0131. Kendimizi evimizde gibi hissettik. G\xf6n\xfcl rahatl\u0131\u011F\u0131yla tavsiye ediyoruz, tekrar gelmek i\xe7in sab\u0131rs\u0131zlan\u0131yoruz. Her \u015Fey i\xe7in \xe7ok te\u015Fekk\xfcr ederiz! \uD83C\uDF38\u2728",
        name: "Gulistan Ba\u015Fkut",
        rating: 5
    },
    {
        text: "G\xf6rd\xfc\u011F\xfcm t\xfcm firmalardan daha h\u0131zl\u0131 d\xf6n\xfc\u015F, daha iyi ilgi ve daha do\u011Fru bilgiyi bana aktard\u0131klar\u0131 i\xe7in \xe7ok te\u015Fekk\xfcr ediyorum. \xc7al\u0131\u015Fanlar\u0131n\u0131z\u0131 tebrik ediyorum ve ba\u015Far\u0131lar\u0131n\u0131n devam\u0131n\u0131 diliyorum. Ayr\u0131ca belirtmek isterim ki gece saat 23:00",
        name: "Abdullatif Terzi",
        rating: 5
    },
    {
        text: "2023 y\u0131l\u0131nda Kalkan b\xf6lgesindeki konaklamam\u0131zdan son derece memnun kald\u0131\u011F\u0131m\u0131z i\xe7in bu y\u0131l Fethiye i\xe7in de yeniden tercih ettik. Rezervasyon s\xfcrecinden itibaren m\xfc\u015Fteri temsilcilerinin ilgisi, profesyonelli\u011Fi ve \xe7\xf6z\xfcm odakl\u0131 yakla\u015F\u0131m\u0131",
        name: "Gamze Ocakl\u0131",
        rating: 5
    },
    {
        text: "\u0130rtibat kurdu\u011Fumuz Sezen han\u0131m her konuda \xe7ok yard\u0131mc\u0131 ve samimi ileti\u015Fimi ile teredd\xfcts\xfcz g\xfcven duymam\u0131z\u0131 sa\u011Flam\u0131\u015Ft\u0131r. \u0130lgisi ve yard\u0131mc\u0131 yakla\u015F\u0131m i\xe7in kendisine te\u015Fekk\xfcr ediyoruz...",
        name: "\xd6mer KIRCA",
        rating: 5
    },
    {
        text: "\xc7ok h\u0131zl\u0131 ve sonu\xe7 odakl\u0131 bi rezervasyon s\xfcreci sunuyorlar. 2025 ve 2026 olarak 2 kere rezervasyon yapt\u0131m. Her ikisinde de gayet keyifli bir \u015Fekilde i\u015Flemleri tamamlad\u0131m.",
        name: "Ahmet Korkut Tahao\u011Flu",
        rating: 5
    },
    {
        text: "Bu villada 5 g\xfcn ge\xe7irdim ve ger\xe7ekten son derece memnun kald\u0131m! Her \u015Fey harikayd\u0131; villa tertemizdi, zevkle d\xf6\u015Fenmi\u015Fti ve her detay ince d\xfc\u015F\xfcn\xfclm\xfc\u015Ft\xfc. Ortam hem huzurlu hem de konforluydu.",
        name: "Seray Kutlu",
        rating: 5
    },
    {
        text: "Hayat\u0131mda yapt\u0131\u011F\u0131m en do\u011Fru tatil se\xe7imlerinden biriydi! Villa hem tertemiz hem de inan\u0131lmaz konforluydu. Sessiz, huzurlu ve tamamen kafa dinlemelik bir ortam\u0131 var. \xd6zellikle \xe7ocuklarla gelenler i\xe7in \xe7ok rahat ve g\xfcvenli. Her detay",
        name: "Efsane Gokceoglu",
        rating: 5
    },
    {
        text: "2026 Haziran ay\u0131 i\xe7in \u015Fimdiden Villa Visal\u2019 e rezervasyon yapt\u0131rd\u0131k. Rezervasyon s\xfcrecinde \u0130rem Nur Han\u0131m, Bet\xfcl Han\u0131m ve Sezen Han\u0131m ile telefonda g\xf6r\xfc\u015Fmeler sa\u011Flad\u0131k ve \xe7ok yard\u0131mc\u0131 oldular. \xd6zellikle kendilerine te\u015Fekk\xfcrlerimi",
        name: "Belinay \u015EERBET\xc7\u0130",
        rating: 5
    },
    {
        text: "Antalya Ka\u015Fta Villa Eskizde kald\u0131k. Villan\u0131n t\xfcm detaylar\u0131 harikayd\u0131 ev sahibi \xe7ok ilgili ve g\xfclery\xfczl\xfc idi. Kafan\u0131zda soru i\u015Faretleri ile gitmi\u015Ftik ama hepsi silindi gitti\u011Fimizde. Bizim i\xe7in unutulmaz bir an\u0131 olarak kald\u0131.",
        name: "\u015Eerife Karatoprak",
        rating: 5
    },
    {
        text: "Faralyadaki Villa sparrow 1\u2019de konaklad\u0131k. Villa temiz ve \xe7ok g\xfczeldi , eksik hi\xe7bir \u015Feyi yoktu, manzaras\u0131 10 numarayd\u0131. Villa sahibi G\xf6khan Semerci bey\u2019in ilgi ve alakas\u0131 i\xe7in \xe7ok te\u015Fekk\xfcr ederiz.",
        name: "Nil\xfcfer Yavuz",
        rating: 5
    },
    {
        text: "\u0130ki y\u0131ld\u0131r d\xfczenli olarak geliyoruz ve \xe7ok memnunuz.Temiz d\xfczenli ve huzurlu bir yer.Isletme sahipleri \xe7ok ilgili ve g\xfcler y\xfczl\xfc. Kendi evimiz gibi hissediyoruz herkese tavsiye ederiz\uD83D\uDE0A",
        name: "Meliha78.90 Melis",
        rating: 5
    },
    {
        text: "Ger\xe7ekten g\xfczel bi firma hepsine \xe7ok te\u015Fekk\xfcr ederim benimle rezervasyon boyunca ilgilendiler an\u0131nda d\xf6n\xfc\u015F sa\u011Flad\u0131lar kesinlikle tavsiye ederim",
        name: "Bahriye On\xfc\xe7y\u0131ld\u0131z",
        rating: 5
    },
    {
        text: "Villa kiralama s\xfcrecimiz \xe7ok h\u0131zl\u0131 ve sorunsuz ilerledi. T\xfcm i\u015Flemler g\xfcvenli bir \u015Fekilde tamamland\u0131. \u0130lgi ve desteklerinden dolay\u0131 \xe7ok memnun kald\u0131k, kesinlikle tavsiye ederim.",
        name: "hilal g\xfcvey",
        rating: 5
    },
    {
        text: "Olduk\xe7a keyif ald\u0131\u011F\u0131m\u0131z bir tatil ge\xe7irmekteyiz , rezervasyon departman\u0131nda bulunan Yasemin hanim'a te\u015Fekk\xfcr ederiz \u263A\uFE0F kiralama esnas\u0131nda herhangi bir problem ile kar\u015F\u0131la\u015Fmad\u0131k extra bir \xfccret veya kabal\u0131k da g\xf6rmedi\u011Fimiz gibi ev sahipleri",
        name: "Onur Demir",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcreci ak\u0131c\u0131 ve kolay. SMS, e-mail ve Whatsapp bidirinleri geliyor. Whatsapp hatt\u0131 ile sorular\u0131n\u0131z\u0131 direkt sorabiliyorsunuz. Yard\u0131mc\u0131 oluyorlar her konuda.",
        name: "S\xfcleyman Demircan",
        rating: 5
    },
    {
        text: "Fethiye farkta maki ev i\xe7in rezervasyon ba\u015Flamas\u0131ndan sat\u0131n alma i\u015Flemine kadar \xe7ok g\xfczel ilgilendiler. Ve sorunsuz \u015Fekilde rezervasyon i\u015Flemini tamamlad\u0131m. \u0130lgileri ve g\xfczel hizmetleri i\xe7in \xe7ok te\u015Fekk\xfcr ederim \uD83D\uDE4F\uD83C\uDFFB\uD83C\uDF38",
        name: "BAHAR TU\u011ECU",
        rating: 5
    },
    {
        text: "Gece yar\u0131s\u0131 bile \xe7al\u0131\u015F\u0131yorlar whatsapp ileti\u015Fimi kurdum destek oldular. \xc7ok ilgilendiler t\xfcm s\xfcre\xe7 boyunca, Te\u015Fekk\xfcrler.",
        name: "Berkay Colakoglu",
        rating: 5
    },
    {
        text: "Yol biraz zorlu gelse de villay\u0131 g\xf6rd\xfckten sonra ger\xe7ekten de\u011Fdi dedik. Villa harika i\xe7erisinde b\xfct\xfcn ihtiya\xe7lar\u0131m\u0131z\u0131 giderecek ekipmanlar mevcut. Tost makinesi,kahve ve \xe7ay makinesi,f\u0131r\u0131n,mikrodalga \xe7ama\u015F\u0131r ve bula\u015F\u0131k makinesi her \u015Fey",
        name: "Fatih y\u0131lmaz",
        rating: 5
    },
    {
        text: "Villa rezervasyonumuzda tarih de\u011Fi\u015Fikli\u011Fi yapmak istedi\u011Fimizde ev sahibinin kat\u0131 kurallar\u0131na ra\u011Fmen, villa villam m\xfc\u015Fteri hizmetlerinin deste\u011Fi ile ma\u011Fdur edilmeden talebimiz ger\xe7ekle\u015Ftirildi.",
        name: "\u0130rem G\xfclten",
        rating: 5
    },
    {
        text: "Hen\xfcz sadece rezervasyon yapt\u0131rd\u0131k fakat rezervasyon a\u015Famas\u0131nda her t\xfcrl\xfc sorulara ve isteklere nazik\xe7e geri d\xf6n\xfc\u015F ve destek sa\u011Flad\u0131klar\u0131 i\xe7in te\u015Fekk\xfcr ederiz",
        name: "Onur \xc7al\u0131\u015Fkany\xfcrek",
        rating: 5
    },
    {
        text: "M\xfc\u015Fteri hizmetleri gayet kibar ve sorulara net cevap veriyorlar problem olmas\u0131 durumunda hemen ilgileniyorlar ben \xe7i\u011Fdem han\u0131mla g\xf6r\xfc\u015Ft\xfcm kendisine \xe7ok te\u015Fekk\xfcr ederim yard\u0131mlar\u0131 i\xe7in :)",
        name: "Regaip \xd6zveren",
        rating: 5
    },
    {
        text: "Birebir ilgilendiler \xe7al\u0131\u015Fanlar\u0131 g\xfcler y\xfczl\xfc ve \xc7\xf6z\xfcm odakl\u0131 Kesinlikle villa kiralarken ileti\u015Fim olarak buray\u0131 tercih ederim villada kald\u0131\u011F\u0131m zamanda yorumu g\xfcncelleyece\u011Fim ama gayet kiralarken birebir ilgilenen i\u015Fletme \u0130lginiz i\xe7in te\u015Fekk\xfcr ederim",
        name: "Semanur G\xfcll\xfc",
        rating: 5
    },
    {
        text: "Cansel han\u0131ma ayr\u0131ca te\u015Fekk\xfcr ederiz t\xfcm opsiyonlar\u0131n\u0131 kullanarak harika enerjisi ile yerimizi tuttuk tatilimizi keyifle ge\xe7irece\u011Fiz in\u015Fallah",
        name: "k\xfcbra sezgin",
        rating: 5
    },
    {
        text: "Temmuz ay\u0131 i\xe7in rezervasyon i\xe7in konu\u015Ftuk \xe7ok ilgiliydi gayet a\xe7\u0131klay\u0131c\u0131 ve yard\u0131mc\u0131 olacak \u015Fekilde konu\u015Fma yapt\u0131k acenteden \u015Fuanl\u0131k bir s\u0131k\u0131nt\u0131m\u0131z yok umar\u0131m tatildede bir sorun ya\u015Famay\u0131z\uD83D\uDE0C",
        name: "Meryem Nur",
        rating: 5
    },
    {
        text: "\u0130lk kiralama a\u015Famas\u0131n\u0131 tamalamak \xe7ok kolay ve ak\u0131c\u0131yd\u0131. T\xfcm rezervasyon i\u015Flemlerini tamalay\u0131p s\xf6zle\u015Fmeyi almam 2 dakika bile s\xfcrmedi. Bu gidi\u015Fat villaya hiri\u015F a\u015Famas\u0131n\u0131n da kolay ve keyifli olaca\u011F\u0131na dair iyi bir i\u015Faret\u2026",
        name: "\xc7a\u011Flar \xdc\xe7e\u015F",
        rating: 5
    },
    {
        text: "Villa Villam \u0130le 2. Tatilimizi Planlad\u0131k. Ge\xe7en Sene Ramazan Bayram\u0131 Tatili \u0130\xe7in Villa Kiralad\u0131k Gitti\u011Fimiz Villada Her\u015Fey En \u0130nce Ayr\u0131nt\u0131s\u0131na Kadar Sorunsuzdu. Aksilikleri Sevmeyen Bir Ki\u015Fi Olarak Bu Senede Villa Villam \xdczerinden Bir Villa",
        name: "Yal\xe7\u0131n S\xfcnb\xfcl",
        rating: 5
    },
    {
        text: "\xf6zellikle nur han\u0131ma \xe7ok te\u015Fekk\xfcrlerimi sunar\u0131m sab\u0131rla yard\u0131mc\u0131 oldu kendileri i\u015Flerinde kolayl\u0131klar dilerim\uD83D\uDC96",
        name: "Yeliz Ko\xe7alan",
        rating: 5
    },
    {
        text: "\xc7ok memnun kald\u0131k. Her \u015Feyi ile m\xfckemmeldi. Ev sahibi han\u0131mefendi de gayet ilgili ve nazik bin han\u0131mefendi. Herkese tavsiye ediyoruz.",
        name: "Sefa OCAKDEN",
        rating: 5
    },
    {
        text: "Bug\xfcn tatilimiz i\xe7in \xe7ok g\xfczel bir ev kiralad\u0131k bu i\u015Flemler esnas\u0131nda bize inan\u0131lmaz yard\u0131mc\u0131 oldular belki 30 kere arad\u0131m her seferinde nazikce ve b\u0131kmadan ileti\u015Fim kurdular \xf6zellikle Sezen Han\u0131ma inceli\u011Fi ve sabr\u0131 i\xe7in te\u015Fekk\xfcr ediyorum iyi ki vars\u0131n Villa Villam\uD83E\uDEE0Trabzondan Narin \xd6\u011Fretmen",
        name: "Narin Yav",
        rating: 5
    },
    {
        text: "\xc7ok H\u0131zl\u0131 ve G\xfcvenilir \u015Fekilde ilerledi her\u015Fey sms ve mail olarak anl\u0131k bilgilendirildim tebrik ederim \uD83D\uDC4D",
        name: "ES H\u0130DROL\u0130K LTD.\u015ET\u0130",
        rating: 5
    },
    {
        text: "\xc7i\u011Fdem han\u0131m \xe7ok yard\u0131mc\u0131 oldu, \xe7\xf6z\xfcm odakl\u0131 yakla\u015Ft\u0131 kendisine \xe7okl te\u015Fekk\xfcr ediyorum.",
        name: "Burak Uzuno\u011Flu",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcrecinde ilgi alakalar\u0131 ger\xe7ekten \xe7ok iyi memnun kald\u0131m \xf6demeye Rezervasyon s\xfcrecinde kartta tek \xe7ekim yap\u0131p taksit imkan\u0131 da olmas\u0131 bal kaymak gibi g\xfczel oldu",
        name: "Muhammet \u0130lengiz",
        rating: 5
    },
    {
        text: "Her \u015Fey g\xfczeldi. Her \u015Fey i\xe7in te\u015Fekk\xfcr ederiz. Necip Bey g\xfczel bir \u015Fekilde a\u011F\u0131rlad\u0131 ilgilendi bizlerle. Villa gayet temiz ve g\xfczel kullan\u0131\u015Fl\u0131yd\u0131 herkese tavsiye edebilirim.",
        name: "emin \xf6zmen",
        rating: 5
    },
    {
        text: "Kiralama s\xfcreci \xe7ok pratik oldu, hen\xfcz konaklama yapmad\u0131m ama m\xfc\u015Fteri ili\u015Fkileri son derece h\u0131zl\u0131 ve \xe7\xf6z\xfcm odakl\u0131.",
        name: "zehra zeynep keklikk\u0131ran",
        rating: 5
    },
    {
        text: "Villa m\xfcthi\u015F temiz yeni ve ferah d\u0131\u2026havuzu efsaneydi, tertemiz ve her sabahda temizlendi. her\u015Fey eksiksiz mevcuttu. ev sahibi \xe7ok cana yak\u0131n g\xfcler y\xfczl\xfc ve ilgiliydi\u2026in\u015Fallah tekrar g\xf6r\xfc\u015Fmek \xfczere. Buda 1-2 resim bizim \xe7ekti\u011Fimiz",
        name: "Canan Karaman",
        rating: 5
    },
    {
        text: "\u0130\u015Flemler h\u0131zl\u0131 ve pratik bir \u015Fekilde halloldu. Rezervasyon talebi g\xf6nderir g\xf6ndermez hemen d\xf6n\xfc\u015F sa\u011Fland\u0131. Ayn\u0131 zamanda whatsappta da ayn\u0131 h\u0131zda d\xf6n\xfc\u015F sa\u011Flamaktalar.",
        name: "Hanife DEL\u0130POYRAZ",
        rating: 5
    },
    {
        text: "Her konuda titizlikle yard\u0131mc\u0131 olduklar\u0131 i\xe7in te\u015Fekk\xfcr ederim m\xfc\u015Fteri dan\u0131\u015Fmanlar\u0131 ger\xe7ekten \xe7ok naif ve anlat\u0131\u015Fl\u0131yd\u0131",
        name: "Faruk Ert\xfcrk",
        rating: 5
    },
    {
        text: "Sordu\u011Fum t\xfcm sorulara titizlikle cevap ald\u0131m. M\xfc\u015Fteri ilginiz i\xe7in te\u015Fekk\xfcr ederim. Tatil tarihimin gelmesini d\xf6rt g\xf6zle bekliyorum.",
        name: "Hilal Karsl\u0131",
        rating: 5
    },
    {
        text: "Rezervasyon konusunda \xe7ok yard\u0131mc\u0131 oldular ve \xe7ok h\u0131zl\u0131 dakik i\u015Flemler ger\xe7ekle\u015Fti.Tatil tarihinde kalaca\u011F\u0131m\u0131z yer i\xe7in gerekli memnuniyet belirtilevektir.",
        name: "Tu\u011F\xe7e \u015Een",
        rating: 5
    },
    {
        text: "\u0130\u015Flemlerimi Sezen han\u0131m ile yapt\u0131m. \xc7ok ilgi ve alakal\u0131 bir yakla\u015F\u0131m\u0131 vard\u0131. Te\u015Fekk\xfcr ederim.",
        name: "G\xf6ktu\u011F Aky\u0131ld\u0131z",
        rating: 5
    },
    {
        text: "Her konuda \xe7ok ilgili davran\u0131ld\u0131. Rezervasyon s\xfcreci ve ileti\u015Fim \xe7ok h\u0131zl\u0131yd\u0131. Her \u015Fey i\xe7in te\u015Fekk\xfcrler",
        name: "Do\u011Fu Ayd\u0131n",
        rating: 5
    },
    {
        text: "Balay\u0131 i\xe7in Nisan ay\u0131nna ismi kaya trio olan villay\u0131 kiralad\u0131m \xe7ok yard\u0131mc\u0131 oldular umar\u0131m villa da sorun \xe7\u0131kmaz te\u015Fekk\xfcr ederim kendilerine",
        name: "\u0130lker \xd6z\xe7elik",
        rating: 5
    },
    {
        text: "Villa \u015E\xfckran Hatun'u kulland\u0131k hem ev sahiplerinden hem villadan \xe7ok memnun kald\u0131k.Ev sahiplerinin(Melek Han\u0131m ve Fatih Bey) ilgi ve alakas\u0131 \xe7ok g\xfczeldi.\xc7ok samimilerdi.Kendilerine \xe7ok te\u015Fekk\xfcr ederiz.Umar\u0131m tekrar g\xf6r\xfc\u015F\xfcr\xfcz.",
        name: "Veli \u0130hsan",
        rating: 5
    },
    {
        text: "Harika ve ilgili bir s\xfcre\xe7ti, \u0130rem han\u0131ma sonsuz te\u015Fekk\xfcrler her an\u0131m\u0131zda yan\u0131m\u0131zda oldu",
        name: "berna ulucan",
        rating: 5
    },
    {
        text: "M\xfc\u015Fteri hizmetleri bizimle \xe7ok ilgilendi her sorumuza \xf6zenle cevap verildi Sezen han\u0131m da ayr\u0131ca te\u015Fekk\xfcr ederiz \u263A\uFE0F",
        name: "Gokhan Tok",
        rating: 5
    },
    {
        text: "Villa villamdan villa bur\xe7ello villas\u0131n\u0131 kiralad\u0131k \xe7ok memnun kald\u0131k ev sahipleri \xe7ok yard\u0131mc\u0131 oldu ev temizdi ikramlar\u0131 i\xe7in te\u015Fekk\xfcr ederiz tavsiye ediyorum",
        name: "Esma Nur",
        rating: 5
    },
    {
        text: "Tek kelimeyle o kadar soru sormama ra\u011Fmen ileti\u015Fimden hi\xe7 kopmayan bir firma her\u015Fey i\xe7in te\u015Fekk\xfcrler ellerinize sa\u011Fl\u0131k kesinlikle tavsiye ederim",
        name: "M\xfccahit Rakipo\u011Flu",
        rating: 5
    },
    {
        text: "T\xfcm rezervasyon s\xfcrecimiz de bizimle \xe7ok iyi ilgilendi\u011Fi i\xe7in Cansel han\u0131ma te\u015Fekk\xfcr ediyoruz",
        name: "Sinan T\u0131r\u0131nk",
        rating: 5
    },
    {
        text: "M\xdc\u015ETER\u0130 TEMS\u0130LC\u0130S\u0130 ARKADA\u015ELAR COK \u0130LG\u0130L\u0130 BURADAN HEPS\u0130NE \xc7OK TE\u015EEKK\xdcR EDER\u0130M",
        name: "Muhammed Uslu",
        rating: 5
    },
    {
        text: "Hen\xfcz deneyim ya\u015Famad\u0131k ama m\xfc\u015Fteri temsilcileri an\u0131nda d\xf6n\xfc\u015F yap\u0131yorlar ve \xe7ok ilgililer ben \xe7ok memnun kald\u0131m deneyimimden sonrada yorum yapaca\u011F\u0131m",
        name: "G\xfcl",
        rating: 5
    },
    {
        text: "H\u0131zl\u0131 ve g\xfcvenli bir \u015Fekilde rezervasyonumuzu tamamlad\u0131k. Sezen han\u0131m da \xe7ok ilgili ve bilgilendirici bir \u015Fekilde yard\u0131mc\u0131 oldu",
        name: "Elif \u015E",
        rating: 5
    },
    {
        text: "H\u0131zl\u0131 geri d\xf6n\xfc\u015F ve ilgileri i\xe7in \xe7ok te\u015Fekk\xfcr ederim. \xc7ok memnun kald\u0131m.",
        name: "Burak K\xf6m",
        rating: 5
    },
    {
        text: "gayet ilgililerdi b\xfct\xfcn sorular\u0131m\u0131za cevap bulduk i\u0307lgi ve alakadan \xe7ok memnunum.",
        name: "faki soylu",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcrecinde gayet ilgili ve kibar ileti\u015Fimleriyle \xe7ok yard\u0131mc\u0131 oldular \xf6zellikle sezen han\u0131ma te\u015Fekk\xfcrler :)",
        name: "K\xfcbra K\u0131l\u0131\xe7",
        rating: 5
    },
    {
        text: "M\xfc\u015Fteri temsilcileri \xe7ok ilgiliydi bizimle \xe7ok ilgilendiler \xe7ok memnun kald\u0131k \u263A\uFE0F\uD83D\uDE4F\uD83C\uDFFC",
        name: "Meryem Cellat",
        rating: 5
    },
    {
        text: "M\xfc\u015Fteri hizmetlerinden sezen han\u0131m bizimle \xe7ok ilgilendi 10 g\xfcne a\u015Fk\u0131n hangi villay\u0131 tutsak diye karars\u0131z kalm\u0131\u015Ft\u0131k kafam\u0131za tak\u0131lan t\xfcm sorular\u0131 cevaplad\u0131 ne zaman wp \xfczerinden veya sesli olarak arasak hep h\u0131zl\u0131 bir \u015Fekilde d\xf6n\xfc\u015F yapt\u0131 ve ger\xe7ekten \xe7ok g\xfcler y\xfczl\xfcyd\xfc \xe7ok ilgilendi tavsiye ederim.",
        name: "Vedat Tu\u011Fra",
        rating: 5
    },
    {
        text: "Rezervasyon i\u015Flemini h\u0131zl\u0131 bir \u015Fekilde tamamlad\u0131k. Sezen Han\u0131m'a ilgi ve alakas\u0131 i\xe7in te\u015Fekk\xfcr ederim.",
        name: "Emre Karaarslan",
        rating: 5
    },
    {
        text: "\xc7ok g\xfczel hizmet ald\u0131m \xe7ok g\xfczel ilgileniyor sorular\u0131ma hemen cevap veriyorlar a\xe7\u0131klay\u0131c\u0131 ve net bir \u015Fekilde h\u0131zl\u0131 d\xf6n\xfc\u015Fler yap\u0131yorlar \xe7ok te\u015Fekk\xfcr ederim villa villam",
        name: "O\u011Fuzhan \xd6zer",
        rating: 5
    },
    {
        text: "\xd6n \xf6deme a\u015Famas\u0131nday\u0131m ve cok memnun kald\u0131m tatilden sonra revize edece\u011Fim Ya\u015Fad\u0131\u011F\u0131m\u0131z En keyifli ve sorunsuz tatil deneyimini ya\u015Fatt\u0131\u011F\u0131 i\xe7in Villa Four",
        name: "Fatih \u015Eahin",
        rating: 5
    },
    {
        text: "Rezervasyon a\u015Famas\u0131nda \xe7ok yard\u0131mc\u0131 oldular. \u0130lgi ve alakalar\u0131n dolay\u0131 villa villam m\xfc\u015Fteri hizmetlerine \xe7ok te\u015Fekk\xfcr ederim.",
        name: "Harun Buyukata",
        rating: 5
    },
    {
        text: "M\xfc\u015Fteri hizmetlerinin h\u0131zl\u0131 gerid\xf6n\xfc\u015Fleri ve yard\u0131mc\u0131 olmalar\u0131ndan dolay\u0131 te\u015Fekk\xfcr ederim",
        name: "Durak \u015Eahin",
        rating: 5
    },
    {
        text: "Villa villam \xfczerinden buldu\u011Fumuz villa portofinoda konaklama yapt\u0131k \xe7ok memnun kald\u0131k villa b\xfcy\xfckt\xfc dizayn\u0131 \xe7ok ho\u015Fumuza gitti merkeze yak\u0131n olmas\u0131 bizim i\xe7in tercih sebeplerin biriydi mevsim dolas\u0131yla biz havuzu kullanamad\u0131k ama havuz",
        name: "Asl\u0131 Yaz\u0131c\u0131",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcrecini olduk\xe7a h\u0131zl\u0131 s\xfcrd\xfcren personele \xe7ok te\u015Fekk\xfcr ederim tavsiye ederim",
        name: "Engin Can Aky\xfcz",
        rating: 5
    },
    {
        text: "Villa villam , ev sahibi ve Eme\u011Fi ge\xe7en herkese \xe7ok te\u015Fekk\xfcr ediyoruz harika bir tatil deneyimi ya\u015Fad\u0131k y\u0131l\u0131n b\xfct\xfcn yorgunlu\u011Funu att\u0131\u011F\u0131m huzur dolu bir yuva idi g\xfcn\xfcn her saati suda ge\xe7en kendimize \xf6zel bir tatil deneyimi ya\u015Fad\u0131k \u0130lkan Tan\xe7 beye \xe7ok te\u015Fekk\xfcr ederiz.",
        name: "seyfeddin uygun",
        rating: 5
    },
    {
        text: "\u0130lgi ve alaka \xe7ok g\xfczeldi villam\u0131z\u0131 kiralad\u0131k in\u015Fallah villada kald\u0131ktan sonra da g\xf6r\xfc\u015Flerimi buraya yaz\u0131cam",
        name: "Mert Y\u0131lmaz",
        rating: 5
    },
    {
        text: "Hizmet h\u0131zl\u0131 ve \xe7ok iyiydi, her \u015Fey sorunsuz ilerledi. Te\u015Fekk\xfcrler \uD83D\uDE04\uD83D\uDC4D\uD83C\uDFFC",
        name: "Talha Karaca",
        rating: 5
    },
    {
        text: "G\xfcvenilir ve g\xfczel bir site ilgileri \xe7ok g\xfczel \xf6zellikle irem han\u0131m her a\u015Famay\u0131 detayl\u0131 olarak bildirdi yard\u0131mc\u0131 oldu harikas\u0131n\u0131z",
        name: "Hilal Sezgin",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcrecinde bana yard\u0131mc\u0131 olan cevaplayan sahra han\u0131ma \xe7ok te\u015Fekk\xfcr ederim .",
        name: "Tu\u011Fba Kaya",
        rating: 5
    },
    {
        text: "\xc7ok ilgililer sorulara an\u0131nda cevap veriyorlar ve detaylar i\xe7in ileti\u015Fime ge\xe7iyorlar te\u015Fekk\xfcrler",
        name: "buket katanalp",
        rating: 5
    },
    {
        text: "Rezervasyon s\u0131ras\u0131nda ilgileri \xe7ok g\xfczeldi herhangi bir sorun ya\u015Famad\u0131m ileti\u015Fim olarak ba\u015Far\u0131l\u0131",
        name: "Nehir can Eker",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcrecinde bize sab\u0131rla yard\u0131mc\u0131 olan Sezen han\u0131ma cok tesekk\xfcrler",
        name: "Tuba Yigito",
        rating: 5
    },
    {
        text: "Villavillam ekibi ile \xe7al\u0131\u015Fmak ger\xe7ekten \xe7ok keyifliydi. Rezervasyon s\xfcrecinden \xf6deme a\u015Famas\u0131na kadar her \u015Fey son derece profesyonel ve \u015Feffaf ilerledi. \u0130leti\u015Fimleri \xe7ok h\u0131zl\u0131, samimi ve \xe7\xf6z\xfcm odakl\u0131. Her soruma an\u0131nda d\xf6n\xfc\u015F yapt\u0131lar ve t\xfcm",
        name: "Ammar Afsa Yilmaz",
        rating: 5
    },
    {
        text: "Keyifli ve h\u0131zl\u0131 bir rezervasyondu ilginen arkada\u015Fa ayr\u0131ca te\u015Fekk\xfcr ediyorum g\xfcvenle tatilinizi planlayabilirsiniz",
        name: "K\xfcbra Y\u0131lmaz",
        rating: 5
    },
    {
        text: "Ben cok memnun kaldim herkesede tavsiye ederim\uD83D\uDC4C",
        name: "Erkan Yurt",
        rating: 5
    },
    {
        text: "Rezervasyon s\xfcrecinde Sena han\u0131m\u0131n yard\u0131mlar\u0131ndan dolay\u0131 \xe7ok te\u015Fekk\xfcr ederim.",
        name: "Burak K\xf6yl\xfc",
        rating: 5
    },
    {
        text: "Sitenin fonksiyonel ve anla\u015F\u0131labilir olmas\u0131 \xe7ok iyi. Talep olu\u015Fturunca h\u0131zl\u0131 bir geri d\xf6n\xfc\u015F sa\u011Flanmas\u0131 ve talep uygunlu\u011Fundan sonraki s\xfcre\xe7lerin i\u015Fleyi\u015Fi \xe7ok daha iyi ve g\xfcven verici. G\xf6n\xfcl rahatl\u0131\u011F\u0131yla rezervasyonumuzu olu\u015Fturduk ve villa",
        name: "AYTEK \xd6Z\xc7OPUR",
        rating: 5
    },
    {
        text: "Son derece g\xfcvenilir bir site. \xc7a\u011Fr\u0131 merkezi \xe7al\u0131\u015Fanlar\u0131 \xe7\xf6z\xfcm odakl\u0131 yakla\u015F\u0131m sunmaktad\u0131r. Ne zaman arad\u0131 isem ula\u015Ft\u0131m ve usanmadan b\u0131kmadan sorular\u0131m\u0131z\u0131 i\xe7tenlikle cevaplad\u0131lar. \xc7evremdeki herkese \xf6neriyorum ve \xf6nermeye devam edece\u011Fim. Te\u015Fekk\xfcr ederiz.",
        name: "Ufuk Altuner",
        rating: 5
    },
    {
        text: "Villa villam m\xfc\u015Fteri hizmetleri 5 y\u0131ld\u0131z\u0131 sonuna kadar hak ediyor te\u015Fekk\xfcrler her\u015Fey i\xe7in\u2026",
        name: "\u0130smail Burak \u015Een",
        rating: 5
    },
    {
        text: "yillardir villa villamdan kiraliyoruz ve hic bir zaman sorun yasamadik. gecen sene kiraliyip \xf6n \xf6deme yapmistik ama geri iptal etmek zorunda kalmistik. \xf6n \xf6demeyi bu sene kullandik. yani dediklerinde durdular o para yok olmadi bunun icin",
        name: "Nhl s.",
        rating: 5
    },
    {
        text: "Yapt\u0131\u011F\u0131m her i\u015Flemden sonra gerekli bilgileri an\u0131nda bana ula\u015Ft\u0131rd\u0131lar. Rezervasyon s\u0131ras\u0131nda da herhangi bir sorun ya\u015Famad\u0131m. 2 sene \xf6nce de bu siteden villa kiralam\u0131\u015Ft\u0131k o zaman da bir sorun ya\u015Famam\u0131\u015Ft\u0131k. Bu siteyi g\xf6n\xfcl rahatl\u0131\u011F\u0131yla tavsiye ederim. \xc7al\u0131\u015Fanlar\u0131n ilgi ve alakas\u0131ndan \xf6t\xfcr\xfc te\u015Fekk\xfcr ederim.",
        name: "Selver Erdem",
        rating: 5
    },
    {
        text: "Kiralama s\xfcrecindeki detayl\u0131 bilgi payla\u015F\u0131m\u0131 ve m\xfc\u015Fteri temsilcisi yakla\u015F\u0131m\u0131ndan gayet memnun kald\u0131m, kolay ilerledi rezervasyon a\u015Famas\u0131 tam destek g\xf6rd\xfcm. Tatil sonras\u0131 deneyimimi payla\u015F\u0131r\u0131m, te\u015Fekk\xfcrler.",
        name: "Didem Denizli",
        rating: 5
    }, 
];

// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
;// CONCATENATED MODULE: ./components/Index/Review.js












var GoogleLogo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: className || "w-6 h-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            transform: "matrix(1, 0, 0, 1, 27.009001, -39.238998)",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M -3.264 51.509 C -3.264 50.719 -3.334 49.969 -3.454 49.239 L -14.754 49.239 L -14.754 53.749 L -8.284 53.749 C -8.574 55.225 -9.424 56.474 -10.686 57.324 L -10.686 60.325 L -6.842 60.325 C -4.608 58.235 -3.264 55.159 -3.264 51.509 Z",
                    fill: "#4285F4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M -14.754 63.239 C -11.516 63.239 -8.801 62.157 -6.821 60.324 L -10.685 57.323 C -11.761 58.044 -13.138 58.469 -14.754 58.469 C -17.869 58.469 -20.518 56.364 -21.464 53.535 L -25.276 53.535 L -25.276 56.453 C -23.414 60.188 -19.542 63.239 -14.754 63.239 Z",
                    fill: "#34A853"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M -21.464 53.535 C -21.711 52.801 -21.838 52.016 -21.838 51.213 C -21.838 50.407 -21.711 49.623 -21.464 48.889 L -21.464 45.971 L -25.276 45.971 C -26.046 47.508 -26.488 49.225 -26.488 51.213 C -26.488 53.197 -26.046 54.918 -25.276 56.453 L -21.464 53.535 Z",
                    fill: "#FBBC05"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M -14.754 43.955 C -12.983 43.955 -11.396 44.57 -10.146 45.749 L -6.741 42.34 C -8.802 40.418 -11.516 39.239 -14.754 39.239 C -19.542 39.239 -23.414 42.29 -25.276 46.025 L -21.464 48.943 C -20.518 46.113 -17.869 43.955 -14.754 43.955 Z",
                    fill: "#EA4335"
                })
            ]
        })
    });
};
var Review = function(param) {
    var data = param.data;
    var ref = (0,TranslationContext/* useTranslation */.m)(), homeReviewLeftTitleSmall = ref.homeReviewLeftTitleSmall, homeReviewLeftTitle = ref.homeReviewLeftTitle, homeReviewLeftText = ref.homeReviewLeftText, reviewsText = ref.reviews, allReviews = ref.allReviews, googleReviewsTitle = ref.googleReviewsTitle, googleReviewsCount = ref.googleReviewsCount, viewAllReviews = ref.viewAllReviews, writeReviewShort = ref.writeReviewShort;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto bg-teklif-1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex container flex-col lg:flex-row px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-teklif-gra w-full lg:w-1/3 pt-16 pb-14 text-white flex flex-col items-center lg:items-start content-center px-12 lg:pl-[1.1rem] lg:pr-0 2xl:pl-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xl",
                                children: homeReviewLeftTitleSmall || "Yard\u0131ma m\u0131 ihtiyac\u0131n var?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-3xl text-center lg:text-left font-bold -mt-1",
                                children: homeReviewLeftTitle || "Villa Bulma Sihirbaz\u0131"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "opacity-80 mt-3 lg:pr-24 text-sm text-center lg:text-left",
                                children: homeReviewLeftText || "Se\xe7mekte zorlan\u0131yor musunuz? Formu doldurun, sizin i\xe7in en uygun evleri listeleyip sunal\u0131m."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (data === null || data === void 0 ? void 0 : data.url) || "/iletisim",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    title: (data === null || data === void 0 ? void 0 : data.title) || "Formu Doldur",
                                    className: "bg-brand-blue-2 font-bold text-sm text-white py-4 px-8 mt-12 hover:opacity-90 transition-opacity",
                                    children: (data === null || data === void 0 ? void 0 : data.kisa_baslik) || "Teklif Al"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:w-2/3 bg-white relative lg:pl-8 xl:pl-16 lg:pt-1 flex flex-col justify-between lg:pr-[1.1rem] 2xl:pr-0 " + (Review_module_default()).ReviewWrap,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col lg:flex-row justify-between items-center bg-primary lg:bg-white pt-8 pb-8 lg:py-8 lg:pr-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col mb-4 lg:mb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-center lg:justify-start gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "bg-white p-2 rounded-full shadow-sm hidden lg:block border border-gray-100",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleLogo, {
                                                            className: "w-6 h-6"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-center lg:text-left text-white lg:text-orange font-bold text-lg lg:text-2xl",
                                                        children: googleReviewsTitle
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center justify-center lg:justify-start gap-2 mt-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-white lg:text-gray-800 font-bold text-xl",
                                                        children: "4.8"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex text-yellow-400",
                                                        children: (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                className: "w-5 h-5 fill-current",
                                                                viewBox: "0 0 24 24",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                                                                })
                                                            }, i);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-white lg:text-gray-500 text-sm font-medium ml-1",
                                                        children: googleReviewsCount
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "https://g.page/r/Cc84qp7cJY5HEBM/review",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "bg-white text-primary lg:bg-primary lg:text-white border border-primary font-bold text-xs py-3 px-6 hover:bg-orange hover:text-white hover:border-orange transition-colors flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                className: "w-4 h-4",
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: "2",
                                                    d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                                })
                                            }),
                                            writeReviewShort
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative pb-12 pr-0 lg:pr-8 mt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "px-10 h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                            spaceBetween: 20,
                                            slidesPerView: 1,
                                            navigation: {
                                                nextEl: ".review-next",
                                                prevEl: ".review-prev"
                                            },
                                            pagination: {
                                                el: ".review-pagination",
                                                clickable: true
                                            },
                                            modules: [
                                                swiper_esm/* Autoplay */.pt,
                                                swiper_esm/* Pagination */.tl,
                                                swiper_esm/* Virtual */.eZ,
                                                swiper_esm/* Navigation */.W_
                                            ],
                                            autoplay: {
                                                delay: 4000,
                                                disableOnInteraction: false
                                            },
                                            breakpoints: {
                                                768: {
                                                    slidesPerView: 2
                                                }
                                            },
                                            className: "h-full",
                                            children: googleReviews.slice(0, 15).map(function(review, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                    virtualIndex: i,
                                                    className: "h-auto",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "bg-gray-50 p-6 h-full flex flex-col border border-gray-100 rounded",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex justify-between items-start mb-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "flex text-yellow-400",
                                                                        children: (0,_to_consumable_array/* default */.Z)(Array(5)).map(function(_, i) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                                className: "w-4 h-4 fill-current",
                                                                                viewBox: "0 0 24 24",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                                                                                })
                                                                            }, i);
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "flex items-center gap-1.5 bg-white border border-gray-200 px-2.5 py-1 rounded-full shadow-sm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleLogo, {
                                                                                className: "w-3.5 h-3.5"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "text-[10px] font-bold text-gray-500 tracking-wider mt-0.5",
                                                                                children: "GOOGLE"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "text-gray-600 text-sm italic leading-relaxed flex-grow line-clamp-4 mb-4",
                                                                children: [
                                                                    '"',
                                                                    review.text,
                                                                    '"'
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "flex items-center gap-3 mt-auto pt-4 border-t border-gray-200",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "w-8 h-8 bg-gray-200 flex items-center justify-center text-gray-600 font-bold text-xs uppercase rounded-full",
                                                                        children: review.name.charAt(0)
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "font-semibold text-gray-800 text-sm",
                                                                        children: review.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, i);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "review-prev absolute left-0 lg:left-2 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-gray-400 hover:text-orange transition-colors",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "w-8 h-8",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M15 19l-7-7 7-7"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "review-next absolute right-0 lg:right-10 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-gray-400 hover:text-orange transition-colors",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "w-8 h-8",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M9 5l7 7-7 7"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "review-pagination absolute bottom-0 left-0 right-0 flex justify-center gap-2 z-10"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center lg:justify-end pr-0 lg:pr-8 mt-4 mb-4 lg:mb-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    href: "https://g.page/r/Cc84qp7cJY5HEBM/review",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "text-primary font-bold text-sm hover:text-orange transition-colors flex items-center gap-1",
                                    children: [
                                        viewAllReviews,
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "w-4 h-4",
                                            fill: "none",
                                            stroke: "currentColor",
                                            viewBox: "0 0 24 24",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                strokeWidth: "2",
                                                d: "M9 5l7 7-7 7"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-auto"
            })
        ]
    });
};
/* harmony default export */ var Index_Review = (Review);


/***/ }),

/***/ 2082:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ReviewWrap":"Review_ReviewWrap__AXoao"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);